<script setup>
import {useUsersStore} from "@/stores"
import PreferredTabsContent from "@/@core/components/PreferredTabsContent.vue"
import CmsText from '@/@core/components/CmsText.vue'

const usersStore = useUsersStore()
let myUser = null
let loginDialogMode = null
let loginDialogVerificationType = null
let isRunningInIOSAppStore = null;
({ myUser, isRunningInIOSAppStore, loginDialogMode, loginDialogVerificationType } = storeToRefs(usersStore))
</script>

<template>
  <div>
    <!-- Back to Restaurant Admin Button -->
    <div
      v-if="myUser?.profileId"
      class="content-wrapper mt-6 mb-n4"
    >
      <div class="back-button-container">
        <RouterLink
          :to="`/m/${myUser?.profileId}`"
          class="back-button d-flex align-center cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
          <span class="ml-1">Back to Profile</span>
        </RouterLink>
      </div>
    </div>

    <section class="home-masthead">
      <div class="content-wrapper">
        <div class="masthead-content mt-4 mb-2 pl-0 pr-0">
          <div class="title-container text-center">
            <CmsText
              k="restaurants.masthead"
              tag="span"
              class="subtitle-text"
            />
          </div>
          <div class="mt-4 text-center">
            <VBtn
              variant="flat"
              size="small"
              color="primary"
              @click="loginDialogVerificationType = 'restaurant'; loginDialogMode = 'activate';"
            >
              <span>Request Free Restaurant Account</span>
            </VBtn>
          </div>
        </div>
      </div>
    </section>
    <VDivider thickness="2" />
    <PreferredTabsContent />
  </div>
</template>

<style lang="scss" scoped>
  .masthead-content {
    padding: 0 1rem;
    margin: 1rem 0;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
  }

  .title-text {
    font-size: 0.9rem;
    font-weight: 900;
    margin: 0;
    color: var(--ds-text-strong);
  }

  .subtitle-text {
    font-size: 0.85rem;
    font-weight: 400;
    margin: 0;
    color: var(--ds-text-strong);
  }

  .back-button-container {
    padding: 0 4px;
  }

  .back-button {
    padding: 8px 12px;
    color: rgb(51, 51, 51);
    text-decoration: none;
    font-size: 14px;
    transition: background-color 0.2s;
    border-radius: 4px;
    display: inline-flex;
  }

  .back-button:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .back-button svg {
    color: rgb(102, 102, 102);
  }
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
